<template>
  <div class="school" ref="school" v-if="columnList.length>0">
    <div class='title'><p class='font'><i></i>教育资讯<i></i></p></div>
    <div class="tabs">
      <div class="tabs-list">
        <div
          class="tab-item"
          :class="{ active: activeTab == index }"
          v-for="(item, index) in columnList"
          @mouseover="tabChange(item, index)"
          :key="index"
        >
          {{ item.columnName }}
        </div>
      </div>
    </div>
    <div class="school-wrap">
      <div class="school-content">
        <div class="content-list">
          <template v-if="curDatas.topContentList&&curDatas.topContentList.length > 0 ">
            <div
              class="school-item"
              v-for="(item, index) in curDatas.topContentList.slice(0, 5)"
              :key="index"
            >
              <div class="swiper-container no-scale" >
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <a
                      :href="item.url"
                      target="_blank"
                      class="img"
                      v-if="item.url && item.url !== ''"
                    >
                      <img :src="item.coverImage" />
                      <div class="info">
                        <div class="info-title" :title="item.title">
                          {{ item.title }}
                        </div>
                        <div class="info-des">{{ item.subtitle }}</div>
                      </div>
                    </a>
                    <router-link
                      :to="{
                        path: '/yt/detail',
                        query: { contentId: item.contentId, tabName: curDatas.columnName ,num:2},
                      }"
                      target="_blank"
                      class="img"
                      v-else
                    >
                      <img :src="item.coverImage" />
                      <div class="info">
                        <div class="info-title" :title="item.title">
                          {{ item.title }}
                        </div>
                        <div class="info-des">{{ item.subtitle }}</div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="no-data" v-else>
            <no-data></no-data>
          </div>
        </div>
      </div>
      <div class="more" @click="toList"><img src='@/assets/images/ytHome/check-more.png'>查看更多</div>
    </div>
  </div>
</template>
<script>
import "../../assets/static/swiper.min.css";
import Swiper from "../../assets/static/swiper.min.js";
import noData from "../../components/common/Nodata.vue";
export default {
  data() {
    return {
      activeTab:0,
      activeList: [],
      curDatas:'',
      init: false,
    };
  },
  created() {
    if(this.columnList.length>0){
       this.curDatas=this.columnList[0];
    }
   
    // window.addEventListener("scroll", this.handleScroll, true);
  },
  components: { noData },
  watch: {
    columnList(n) {
      if (n.length > 0) {
        this.activeTab = 0;
        this.curDatas=n[0];
        // this.computedList();
      }
    },
  },
  props: {
    columnList: [],
  },
  methods: {
    // 鼠标滑动至学校介绍
    // handleScroll() {
    //   let scrollTop =
    //     document.querySelector(".vl-main").scrollTop ||
    //     document.documentElement.scrollTop;
    //   let schoolHeight = this.$refs.school.offsetTop;

    //   if (schoolHeight - scrollTop < 600) {
    //     if (!this.init) {
    //       this.init = true;
    //     }
    //   } else {
    //     this.init = false;
    //   }
    // },
   
    tabChange(item, index) {
      this.activeTab = index;
      this.curDatas=Object.assign(item);
    },
    toList() {
      this.$router.push({
        path: "/yt/list",
        query: {
          tabName: this.curDatas.columnName,
          num:2
        },
      });
    },
  },
  // destroyed() {
  //   window.removeEventListener("scroll", this.handleScroll, true);
  // },
};
</script>

<style scoped lang="scss">
.school {
  position: relative;
  .school-wrap {
    // background: #7d3b00;
    padding-top: 30px;
    padding-bottom: 40px;
    overflow: hidden;
    .school-content {
      width: 1200px;
      height: 1080px;
      overflow: hidden;
      margin: 0 auto;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        width: 543px;
        height: 592px;
        right: -181px;
        top: 205px;
        background: url("../../assets/images/ytHome/item-bg1.png") no-repeat
          center;
        background-size: 100%;
        z-index: 1;
      }
      .content-list {
        position: absolute;
        left: 0px;
        top: 0px;
        transition: all 1s;
      }
      .active-school-list {
        opacity: 1 !important;
        z-index: 4 !important;
      }
      .no-data {
        padding: 170px 0px;
        background-color: #ffffff;
        border-radius: 4px;
        width: 1200px;
      }
      .school-item {
        width: 385px;
        display: inline-block;
        margin-right: 20px;
        position: relative;
        margin-bottom: 20px;
        z-index: 2;
        vertical-align: top;

        &:first-child {
          width: 793px;
          .info {
            background-size: 10% !important;
            background-image: url("../../assets/images/ytHome/school-bg.png");
            background-repeat: no-repeat;
            background-position-x: right;
            background-position-y: bottom;
          }
        }
        &:nth-child(2) {
          margin-right: 0px;
        }
        &:nth-child(5) {
          margin-right: 0px;
        }
        height: 490px;
        .swiper-container {
          transition: all 1s ease-out 0s;
          transform: translateY(-50px);
          opacity: 0;
          height: 100%;
          box-shadow: 0px 2px 6px 1px rgba(145, 92, 44, 0.2);
          .swiper-wrapper {
            .swiper-slide {
              cursor: pointer;
            }
          }
        }
        .no-scale {
          opacity: 1;
          transform: none;
        }
        .img {
          height: 420px;
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            height: 420px;
            transition: all 0.3s ease-out;
          }
          &:hover {
            img {
              transform: scale(1.05);
            }
          }
        }
        .info {
          height: 116px;
          width: 100%;
          background-color: #ffffff;
          position: absolute;
          bottom: 0px;
          left: 0px;
          border-radius: 0px 30px 4px 4px;
          padding: 16px 20px;
          .info-title {
            font-size: 22px;
            color: #6c3403;
            line-height: 29p;
            margin-bottom: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .info-des {
            font-size: 14px;
            color: #595552;
            line-height: 22px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            word-wrap: break-word;
          }
        }
      }
    }
  
  }
}
</style>